export default __webpack_public_path__ + "static/media/avails-on-dark.e1c5105f.png";